export default __webpack_public_path__ + "b513ba47d89e153b27367e14977bc258.png";